import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, CircularProgress, Grid } from '@material-ui/core';
import axios from 'axios';
import { Edit as EditIcon } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { useState } from 'react';


interface IProps {
    selectedItems: string[]
    onClose: () => void
}

let ChangeUser = (props: IProps) => {
    let { enqueueSnackbar } = useSnackbar();

    let [isOpen, setOpen] = useState(false);
    let [isLoading, setLoading] = useState(false);
    let [isSearchDone, setSearchDone] = useState(false);
    let [exist, setExist] = useState(false);
    let [email, setEmail] = useState('');


    let checkUserOnCognito = async () => {
        try {
            setLoading(true);
            setSearchDone(false);

            let res = await axios.get('/api/UserManagement/CheckUserExistOnCognito', { params: { email } });
            setExist(res.data);
            setSearchDone(true);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }

    let updateUserRegistrations = async () => {
        try {
            setLoading(true);

            let request = {
                selectedItems: props.selectedItems,
                email
            }

            await axios.post('/api/Product/ChangeUserForRegistrations', request);
            enqueueSnackbar("User has been changed", { variant: "success" });
            close(true);

        } catch (err) {
            setLoading(false);
        }
    }

    let close = (refresh = false) => {
        setLoading(false);
        setOpen(false);
        setSearchDone(false);
        setEmail('');

        if (refresh === true)
            props.onClose();
    }


    return (
        <>
            <Button variant="contained" color="primary" size="small" onClick={() => setOpen(true)}>
                <EditIcon />&nbsp;Change user
            </Button>

            <Dialog
                open={isOpen}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle disableTypography id="alert-dialog-title">
                    <Typography variant="h4">
                        Change user for {props.selectedItems.length} registrations
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs>
                            {isSearchDone === true &&
                                <>
                                    {exist === true && <Typography>User will see selected products when he logs into warranty website with email '{email}'</Typography>}
                                    {exist === false && <Typography>User will see selected products when he register a new account in warranty website with email '{email}'</Typography>}
                                </>
                            }
                            {isSearchDone === false &&
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    type="email"
                                    label="New user email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} variant="outlined" onClick={() => close()}>
                        Cancel
                    </Button>
                    <Button
                        disabled={isLoading}
                        variant="contained"
                        color="primary"
                        onClick={isSearchDone === true ? updateUserRegistrations : checkUserOnCognito}
                    >
                        {isSearchDone === true ? 'Confirm' : 'Proceed'}{isLoading && <>&nbsp;<CircularProgress size={20} /></>}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ChangeUser;